module.exports = __webpack_public_path__ + "media/backgrounds/purple-bg-strip-6e727a2e.png";